// import customizeModalThemeBanner from "../../../assets/img/modals/customize-modal-theme-banner.svg";
import returnIcon from "../../../assets/img/modals/return.svg";
import style from "../../../assets/css/project.css";
import { useEffect, useState } from "react";
import { hideLoader, showLoader } from "../../loader";
import { apiUrl } from "../../../utils/url";
import { Alert } from "react-bootstrap";
import ErrorMessage from "../../errors/errorMessage";
import { useDispatch, useSelector } from "react-redux";
import CustomThemeModal from "../../custom-theme/custom-theme-modal";
import customTheme from "../../../assets/img/custom-theme.png"
import profileStyleDefault from "../../../assets/img/default.png"
import profileStyleBanner from "../../../assets/img/banner.png"

const ThemeCustomize = ({ handleSubmit, error, setBannerModal }) => {

    const dispatch = useDispatch()
    const value = useSelector(state => state?.customizeThemeReducer);
    const theme = useSelector(state => state?.allThemesReducer);
    const { bannerSelected } = useSelector(state => state);
    const { linkStyleSelected } = useSelector(state => state);
    const [openCustomTheme, setOpenCustomTheme] = useState(false)
    const [openCustomThemeFrom, setOpenCustomThemeFrom] = useState("customize")

    function handleChange(e, id, isCustom) {
        if (isCustom) {
            dispatch({ type: "SET_CUSTOMIZE_THEME", payload: { ...value, ["theme"]: "custom_theme", selectedTheme: "custom_theme" } })
            setOpenCustomTheme(true)
        }
        else {
            dispatch({ type: "SET_CUSTOMIZE_THEME", payload: { ...value, ["theme"]: e.target.dataset?.value, selectedTheme: id } })
        }
    }

    $(document).on('click', '.theme-selection-indiv', function () {
        $(".theme-selection-indiv").removeClass('selected-theme');
        $(this).addClass('selected-theme');
        var src_value = $(this).find('span').attr('data-bg');

        $("input[name='theme_color']").val(src_value);
    });

    // $(document).on('click', '.profile-style-div', function () {
    //     if ($(this).attr("data-value") == "banner")
    //         dispatch({ type: "SET_BANNER_SELECTED", payload: "banner" })
    //     else
    //         dispatch({ type: "SET_BANNER_SELECTED", payload: "regular" })
    // });

    $(document).on('click', '.link-style-div', function () {
        if ($(this).attr("data-value") == "plain")
            dispatch({ type: "SET_LINKSTYLE_SELECTED", payload: "plain" })
        else
            dispatch({ type: "SET_LINKSTYLE_SELECTED", payload: "gradient" })
    });

    const bannerShow = () => dispatch({ type: "SET_BANNER_MODAL", payload: { from: "banners", show: true } })

    const removeBanner = () => {
        dispatch({ type: "SET_BANNER_SELECTED", payload: "regular" })
        dispatch({ type: "SET_CUSTOMIZE_THEME", payload: { ...value, profile_style: "regular", banner: null, editLink: null, selected: null } })
    }

    useEffect(() => {
        if (value?.profile_style) dispatch({ type: "SET_BANNER_SELECTED", payload: value?.profile_style })
    }, [value?.profile_style])

    useEffect(() => {
        if (value?.link_style) dispatch({ type: "SET_LINKSTYLE_SELECTED", payload: value?.link_style })
    }, [value?.link_style])

    return (
        <>
            <div class="tab-pane fade customize-page-main active show" id="customizePageTheme" role="tabpanel" aria-labelledby="theme-tab">

                <h4>Pick Theme:</h4>
                <ErrorMessage error={error} />
                <section>
                    <form
                        style={{ paddingBottom: "60px" }}
                        onSubmit={(e) => {
                            e.preventDefault();
                            
// console.log("Customiz", value)
                            handleSubmit(value, value.isEdit, bannerSelected,linkStyleSelected )
                        }}>
                        {/* <div class="form-group mt-3">
                            <img src={customizeModalThemeBanner} width="100%" alt="" />
                        </div> */}

{/* Theme section */}
                        <div class="themes-selection py-3">
                            <div class="theme-main-right col-lg-12 pl-0 pr-0 pl-lg-1">

                                {theme?.length > 0 &&
                                    theme?.map((val) => (
                                        // (val?.id == value?.selectedTheme) ?
                                        //     <div class="theme-selection-div " key={val.id} data-value={val.id} onClick={(e) => handleChange(e, val?.id)}>{console.log("valss",val)}
                                        //         <div class={`theme-selection-indiv selected-theme`} style={{background:`linear-gradient(180deg, ${JSON.parse(val.meta).header.color}, #F6F6F6) 30%`}} data-value={val.id} onClick={(e) => handleChange(e, val?.id)}>
                                        //             <span className="h-100" data-bg={`group${val.id}`} data-value={val.id} onClick={(e) => handleChange(e, val?.id)}>
                                        //                 <img src={val?.image} width="100px" data-value={val.id} onClick={(e) => handleChange(e, val?.id)} />
                                        //                 <small>{val.name}</small>
                                        //             </span>
                                        //         </div>
                                        //     </div>
                                            // :
                                            <div class="theme-selection-div" key={val.id} data-value={val.id} onClick={(e) => handleChange(e, val?.id)}>
                                                <div class={`theme-selection-indiv ${val?.id == value?.selectedTheme ? 'selected-theme' : val.name?.replace(" ", "_")}`} style={{background:`linear-gradient(180deg, ${JSON.parse(val.meta).header.color}, #F6F6F6) 30%`}} data-value={val.id} onClick={(e) => handleChange(e, val?.id)}>
                                                    <span className="h-100" data-bg={`group${val.id}`} data-value={val.id} onClick={(e) => handleChange(e, val?.id)}>
                                                        <img src={val?.image} width="100px" data-value={val.id} onClick={(e) => handleChange(e, val?.id)} style={{ filter: "drop-shadow(0px 0px 23px rgba(57, 51, 69, 0.09))" }} />
                                                        <small data-value={val.id} onClick={(e) => handleChange(e, val?.id)}>{val.name}</small>
                                                    </span>
                                                </div>
                                            </div>
                                    ))}

                                <div class="theme-selection-div " onClick={(e) => {
                                    handleChange(e, null, true);
                                }}>
                                    <div onClick={(e) => handleChange(e, null, true)} className={`product-theme theme-selection-indiv custome-box-u ${value?.selectedTheme == "custom_theme" ? "selected-theme" : null}`} data-theme="custom_theme">
                                        <span className="h-100" data-theme="custom_theme box-area-u">
                                            <div className="custome-gred-box">
                                                <img src={customTheme} className="gred-theme-main"/>
                                                <img src={customTheme} className="gred-theme-bg"/>
                                            </div>
                                            <div className="theme-text-u">
                                                Custom Theme
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {openCustomTheme && <CustomThemeModal setOpenCustomTheme={setOpenCustomTheme} openCustomTheme={openCustomTheme} openCustomThemeFrom={openCustomThemeFrom} />}
{/* Banner section */}


                        {/* <div className="d-flex w-100 pt-4 pl-4">
                            <h4 class="m-0 w-75">Profile Style:</h4> */}
                            {/* <button type="button" onClick={bannerShow} disabled={bannerSelected != "banner"} data-id="505308" class="btn w-25 btn-white banner-upload-btn2 bg-white form-control">
                                <i class="fa fa-cog"></i>&nbsp; Select Banner
                            </button> */}
                        {/* </div> */}

                        {/* <div class="d-flex m-0 pt-4 pb-4 profile-style-div-main">
                            <div class="">
                                <div class={`col-12 text-center profile-style-div prof-u ${(bannerSelected == "regular") && "active"}`} data-type="default" data-value="regular">
                                    <img src={profileStyleDefault} width="100%" alt="" />
                                </div>
                                <h2 className="bannerdef">Default</h2>
                            </div>
                            <div class="ml-10-u">
                                <div class={`col-12 text-center profile-style-div prof-u ${(bannerSelected == "banner") && "active"}`} data-value="banner">
                                    <img src={profileStyleBanner} width="100%" alt="" />
                                </div>
                                <h2 className="bannerdef">Banner</h2>
                            </div>
                            <div className="cont-banner-area">
                                <h3 className="banner-text">Banner Design</h3>
                                <div className="">
                                    {value?.editLink && (
                                        <div class="banner-area">
                                            <div className="banner-border">
                                                <div class="banner-div-u col-12 text-center p-0" data-type="banner">
                                                    <img style={{borderRadius:'5px'}} src={value?.editLink} width="100%" alt="" />
                                                </div>
                                            </div>
                                            <div class="col-12 text-center" onClick={(e) => removeBanner(value?.selected)}>
                                                <h6 class="mt-2 mb-2 text-center text-red cursor-pointer">Remove Banner</h6>
                                            </div>
                                        </div>)}
                                    <input type="hidden" name="profile_style" id="profile-style" value="banner" />
                                </div>
                                <button type="button" onClick={bannerShow} disabled={bannerSelected != "banner"} data-id="505308" class="btn w-25 newbanner-btn btn-white banner-upload-btn2 bg-white form-control u-control">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C6.41421 0 6.75 0.335786 6.75 0.75V5.25H11.25C11.6642 5.25 12 5.58579 12 6C12 6.41421 11.6642 6.75 11.25 6.75H6.75V11.25C6.75 11.6642 6.41421 12 6 12C5.58579 12 5.25 11.6642 5.25 11.25V6.75H0.75C0.335786 6.75 0 6.41421 0 6C0 5.58579 0.335786 5.25 0.75 5.25H5.25V0.75C5.25 0.335786 5.58579 0 6 0Z" fill="#333333"/></svg>
                                    &nbsp;Upload Banner
                                </button>
                            </div>

                            

                        </div> */}
                        <div className="d-flex w-100 pt-4 pl-4">
                            <h5 class="m-0 w-75">Link Style:</h5>
                        </div> 
                        <div class="d-flex m-0 pt-4 pb-4 profile-style-div-main">
                            <div >
                                <div class={`col-12 text-center link-style-div prof-u ${(linkStyleSelected == "gradient") && "active"}`} data-type="gradient" data-value="gradient">
                                   <div className="link-style-div-content link-style-div-content-gradient">
                                    <img className="invisible " src={profileStyleDefault} alt="" width={"100%"}/>
                                   </div>
                                </div>
                                <h2 className="bannerdef text-dark ">Gradient</h2>
                            </div>
                            <div class="ml-10-u" >
                                <div class={`col-12 text-center link-style-div prof-u ${(linkStyleSelected == "plain") && "active"}`} data-value="plain">
                                    <div className="link-style-div-content" style={{}}>
                                        <img className="invisible " src={profileStyleDefault} alt="" width={"100%"}/>
                                    </div>
                                </div>
                                <h2 className="bannerdef">Plain</h2>
                            </div>
                        </div>

                        <div class="text-center d-flex submit-buttons-fixed">
                            <button type="submit" class=" project-blue-btn ">
                                <b class="me-2">Save Changes</b>
                                <small class=" project-blue-btn-badge ">
                                    <img src={returnIcon} alt="" />
                                </small>
                            </button>
                        </div>
                    </form>
                </section>
            </div>
            {/* {openCustomTheme && <CustomThemeModal setOpenCustomTheme={setOpenCustomTheme} openCustomTheme={openCustomTheme} openCustomThemeFrom={openCustomThemeFrom} />} */}
        </>
    )
}
export default ThemeCustomize
